import emailjs from "@emailjs/browser";
import ENV from "../config";
export async function sendContactFormEmail(formData) {
  await emailjs.send(
    ENV.get().EMAILJS_SERVICE_ID,
    ENV.get().EMAILJS_TEMPLATE_ID,
    formData,
    { publicKey: ENV.get().EMAILJS_PUBLIC_KEY },
  );
}

export async function sendRegisterFormEmail() {}
